const url = "/elder";
// 담당자 리스트
export const getElderDataList = async (conn, callback, reject, pager, setLoading) => {
  const { take, skip, sort, cid, userTerm, rgnCode, dongCode, managerId } = pager;
  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      sort,
      cid: cid,
      userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
      managerId: managerId,
    },
  };
  await conn
    .get(url + "/page", config)
    .then(response => {
      callback(response);
      setLoading(false);
    })
    .catch(error => {
      reject(error);
    });
};

export const setUpdateElder = async (conn, data) => {
  const {
    userId,
    userPassword,
    userTerm,
    birthday,
    userGender,
    rgnCode,
    dongCode,
    address,
    userPhone,
    managerId,
    managerTerm,
    managerPhone,
    protectorTerm,
    protectorPhone,
    installDtm,
    bizType,
    sickType,
    liveType,
    note,
    notePickYn,
    lat,
    lng,
    cid,
  } = data;
 
  const params = {
    userId: userId,
    userPassword: "elder 나중에 로그인 기능 추가할때 변경",
    userTerm: userTerm,
    cid: cid,
    birthday: birthday,
    userGender: userGender,
    rgnCode: rgnCode,
    dongCode: dongCode,
    address: address,
    userPhone: userPhone,
    managerId: managerId,
    managerTerm: managerTerm,
    managerPhone: managerPhone,
    protectorTerm: protectorTerm,
    protectorPhone: protectorPhone,
    installDtm: installDtm,
    bizType: bizType,
    sickType: sickType,
    liveType: liveType,
    note: note,
    notePickYn: notePickYn,
    lat: lat,
    lng: lng,
  };

  const response = await conn.post(url, params);

  return response;
};

export const setUserInsert = async (conn, data) => {
  const { userId, userTerm, userPassword, birthday, userGender, rgnCode, dongCode, address, userPhone, managerId, managerTerm, meainStatCode,
    managerPhone, protectorTerm, protectorPhone, installDtm, bizType, sickType, liveType, note, notePickYn, lat, lng, cid, dangerYn, absenceYn, locationYn, imei } = data;
 
  const params = {
    userId: userId, 
    userTerm: userTerm,
    userTypeCode: 2001,
    meainStatCode: meainStatCode,
    userPassword: "aaaa1234!",
    cid: cid,
    birthday: birthday,
    userGender: userGender,
    rgnCode: rgnCode,
    dongCode: dongCode,
    address: address,
    userPhone: userPhone,
    managerId: managerId,
    managerTerm: managerTerm,
    managerPhone: managerPhone,
    protectorTerm: protectorTerm,
    protectorPhone: protectorPhone,
    installDtm: installDtm,
    bizType: bizType,
    sickType: sickType,
    liveType: liveType,
    note: note,
    notePickYn: notePickYn,
    lat: lat,
    lng: lng,
    dangerYn: dangerYn,
    absenceYn: absenceYn,
    locationYn: locationYn,
    imei: imei,
  };

  const response = await conn.post(url + "/insert", params);

  return response;
};


export const setUserUpdate = async (conn, data) => {
  const { userId, userTerm, birthday, userGender, rgnCode, dongCode, address, userPhone, managerId, managerTerm, managerPhone, meainStatCode,
    protectorTerm, protectorPhone, installDtm, bizType, sickType, liveType, note, notePickYn, lat, lng, cid, dangerYn, absenceYn, locationYn, imei,} = data;
 
  const params = {
    userId: userId,
    userTerm: userTerm,
    meainStatCode: meainStatCode,
    cid: cid,
    birthday: birthday,
    userGender: userGender,
    rgnCode: rgnCode,
    dongCode: dongCode,
    address: address,
    userPhone: userPhone,
    managerId: managerId,
    managerTerm: managerTerm,
    managerPhone: managerPhone,
    protectorTerm: protectorTerm,
    protectorPhone: protectorPhone,
    // installDtm: installDtm,
    bizType: bizType,
    sickType: sickType,
    liveType: liveType,
    note: note,
    notePickYn: notePickYn,
    lat: lat,
    lng: lng,
    dangerYn: dangerYn,
    absenceYn: absenceYn,
    locationYn: locationYn,
    imei: imei,
  };

  const response = await conn.post(url + "/update", params);

  return response;
};

export const setDeleteElder = async (conn, data) => {
  const config = {
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(new Array(data)),
  };
  const response = await conn.delete(url, config);

  return response;
};

export const getElderInfo = async (conn, callback, reject, param) => {
  await conn
    .get("user", {
      params: {
        userId: param.userId,
      },
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};

export const getUserStat = async (conn, data) => {

  const { userId } = data;
  const config = {
    params: {
      userId: userId,
    },
  };
  const response = await conn.get(url + "/userStat", config);

  return response;
};

export const setUserPhoto = async (conn, data) => {
  
  const {userId, fileIdUserPhoto} = data;
 
  const params = {
    userId,
    fileIdUserPhoto,
  };

  const response = await conn.post(url + "/photo", params);

  return response;
};

export const setPlacePhoto1 = async (conn, data) => {
  
  const {userId, fileIdPlacePhoto1} = data;
 
  const params = {
    userId,
    fileIdPlacePhoto1,
  };

  const response = await conn.post(url + "/photo", params);

  return response;
};

export const setPlacePhoto2 = async (conn, data) => {
  
  const {userId, fileIdPlacePhoto2} = data;
 
  const params = {
    userId,
    fileIdPlacePhoto2,
  };

  const response = await conn.post(url + "/photo", params);

  return response;
};


export const getFile = async (conn, data) => {
  const response = await conn.get('/file/display/' + data);

  return response;
};


export const getBehaviorList = async (conn, callback, reject, dataState) => {
  
  await conn
    .get(url + "/behavior/list", {
      params: {
        residenceStatus: dataState.residenceStatus
      }
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};


export const getUserBehaviorList = async (conn, callback, reject, dataState) => {
  
  await conn
    .get(url + "/user/behavior/list", {
      params: {
        userId: dataState.userId,
        selectedDay: dataState.selectedDay,
      },
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};


export const insertUserBehavior = async (conn, dataState, selectedDays, selectedTimes) => {

  const {userId, dayofweek, time, behaviorCode, behaviorTerm, behaviorTermOther, residenceStatus, regiId, regiDtm, editId, editDtm} = dataState;
 
  const params = {
    userId,
    // dayofweek,
    // time,
    behaviorCode,
    behaviorTerm,
    behaviorTermOther,
    residenceStatus,
    regiId,
    regiDtm,
    editId,
    editDtm,
    selectedDays,
    selectedTimes
  };

  const response = await conn.post(url + "/user/behavior/insert", params);

  return response;
};

export const updateUserBehavior = async (conn, dataState) => {
  const {userId, dayofweek, time, behaviorCode, behaviorTerm, behaviorTermOther, residenceStatus, editId, editDtm} = dataState;
 
  const params = {
    userId,
    dayofweek,
    time,
    behaviorCode,
    behaviorTerm,
    behaviorTermOther,
    residenceStatus,
    editId,
    editDtm
  };

  const response = await conn.post(url + "/user/behavior/update", params);

  return response;
};

export const deleteUserBehavior = async (conn, dataState) => {
  const config = {
    headers: { "Content-Type": "application/json" },
    data: dataState,
  };
  const response = await conn.delete(url + "/user/behavior", config);

  return response;
};

export const getDiseaseList = async (conn, callback, reject, dataState) => {
  
  await conn
    .get(url + "/disease/list", {
      params: {
        residenceStatus: dataState.residenceStatus
      }
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};


export const getUserDiseaseList = async (conn, callback, reject, dataState) => {
  
  await conn
    .get(url + "/user/disease/list", {
      params: {
        userId: dataState.userId,
      },
    })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      reject(error);
    });
};


export const insertUserDisease = async (conn, dataState) => {

  const {userId, diseaseCode, diseaseTerm, diseaseTermOther, medicationYn, medicationNote, regiId, regiDtm, editId, editDtm} = dataState;
 
  const params = {
    userId,
    diseaseCode,
    diseaseTerm,
    diseaseTermOther,
    medicationYn,
    medicationNote,
    regiId,
    regiDtm,
    editId,
    editDtm,
  };

  const response = await conn.post(url + "/user/disease/insert", params);

  return response;
};

export const updateUserDisease = async (conn, dataState) => {
  const {userId, dayofweek, time, diseaseCode, diseaseTerm, diseaseTermOther, medicationYn, medicationNote, editId, editDtm} = dataState;
 
  const params = {
    userId,
    diseaseCode,
    diseaseTerm,
    diseaseTermOther,
    medicationYn,
    medicationNote,
    editId,
    editDtm
  };

  const response = await conn.post(url + "/user/disease/update", params);

  return response;
};

export const deleteUserDisease = async (conn, dataState) => {
  const config = {
    headers: { "Content-Type": "application/json" },
    data: dataState,
  };
  const response = await conn.delete(url + "/user/disease", config);

  return response;
};